module.exports = __webpack_public_path__ + "img/logo.ff073cd0.svg";